import { FieldError } from "react-hook-form"
import { ErrorIconWithTooltip } from "../ErrorIconWithTooltip"
import { InputWrapperContainer } from "./InputWrapper.styled"

interface InputWrapperProps {
  /**
   * The field error from React Hook Form
   */
  error?: FieldError
  /**
   * The input component to wrap
   */
  children: React.ReactNode
}

/**
 * Wrapper component for form inputs that displays an error icon with tooltip when there's a validation error
 *
 * @example
 * ```tsx
 * <InputWrapper error={errors.fieldName}>
 *   <TimeInput registerReturn={register("fieldName")} />
 * </InputWrapper>
 * ```
 */
export const InputWrapper = ({ error, children }: InputWrapperProps) => {
  return (
    <InputWrapperContainer alignItems="center" gap="5px">
      {children}
      {error && <ErrorIconWithTooltip errorMessage={error.message} />}
    </InputWrapperContainer>
  )
}
